import { DateCalendar } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import { useEffect, useState } from 'react';
import { ScreeningCalendarProps } from '../../../interfaces/props/SaudeOnline/PAVirtual/ScreeningCalendarProps';
import { sxCalendar } from './sxProps';

dayjs.locale('pt-br');

function ScreeningCalendar(props: ScreeningCalendarProps) {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [monthNum, setMonthNum] = useState<number>(0);
  const { handleMonth, hoursList, handleDate } = { ...props };

  useEffect(() => {
    if (props.selectedDate !== null) {
      setSelectedDate(dayjs(props.selectedDate))
      setMonthNum(dayjs(props.selectedDate).month())
    }
    else {
      setMonthNum(dayjs().month());
    }
  }, [props.selectedDate])

  useEffect(() => {
    const start = dayjs().month(monthNum).startOf('month');
    const end = dayjs().month(monthNum).endOf('month');
    handleMonth(start.toDate(), end.toDate())
  }, [monthNum]);



  const handleDateChange = (date: Dayjs | null) => {
    if (date !== null) {
      setSelectedDate(date);
      handleDate(date.toDate())
    }
  }

  const getDayName = (dayNumber: string) => {
    switch (dayNumber) {
      case 'Do':
        return 'D';
      case '2ª':
        return 'S';
      case '3ª':
        return 'T';
      case '4ª':
        return 'Q';
      case '5ª':
        return 'Q';
      case '6ª':
        return 'S';
      case 'Sá':
        return 'S';
    }
  }

  function disableDays(date: Dayjs) {
    let findDate = hoursList.some(day => dayjs(day.data, 'DD/MM/YYYY').isSame(date));
    return !findDate;
  }

  const handleMonthChange = (date: Dayjs) => {
    setMonthNum(date.month());
  }

  return (
    <div className="calendar">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          sx={sxCalendar}
          value={selectedDate}
          onChange={handleDateChange}
          onMonthChange={handleMonthChange}
          shouldDisableDate={disableDays}
          dayOfWeekFormatter={(day: string) => `${getDayName(day)}`}
        />
      </LocalizationProvider>
    </div>
  );
}

export default ScreeningCalendar;